export default "__VITE_ASSET__CkHNTPSw__"